import { verifyPassword } from "@/services/auth";
import { t } from "i18next";
import { z } from "zod";

interface PasswordChange {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export const PasswordChangeSchema = (): z.ZodEffects<
  z.ZodType<PasswordChange>
> =>
  z
    .object({
      oldPassword: z.string(),
      newPassword: z
        .string()
        .min(6, t("schemas.passwordChange.newPassword.min")),
      confirmNewPassword: z.string(),
    })
    .refine(
      async (data) => {
        const result = await verifyPassword(data.oldPassword);
        return result;
      },
      {
        message: t("schemas.passwordChange.oldPassword.refine"),
        path: ["oldPassword"],
      }
    )
    .refine(
      (data) => {
        return data.newPassword == data.confirmNewPassword;
      },
      {
        message: t("schemas.passwordChange.newPassword.refine"),
        path: ["newPassword"],
      }
    );

export type PasswordChangeSchemaType = z.infer<
  ReturnType<typeof PasswordChangeSchema>
>;

export type PasswordChangeSchemaKey = keyof PasswordChangeSchemaType;
